export default "__VITE_PUBLIC_ASSET__fdd3d847__"